import { AbstractControl } from '@angular/forms';

/**
 * Clase encargada de validar que las contraseñas coincidan, esto sucedera cuando el usuario
 * desee cambiar su clave o contraseña de usuario.
 */
export class ConfirmPasswordValidator {
  /** Función estatica quue recibe el control al cual se le va a aplicar la validación.*/
  static MatchPassword(control: AbstractControl): any {
    /** Variable constante que guarda el valor de la contraseña*/
    const password = control.get('password')?.value;
    /** Variable que guarda el valor del campo re_password*/
    const confirmPassword = control.get('re_password')?.value;

    if (password !== confirmPassword) {
      control.get('re_password')?.setErrors({ confirmPassword: true });
    } else {
      return null;
    }
  }
}
/**
 * Clase encargada de validar el tamaño minimo para una contraseña, en este caso el definido por el cliente es de 8 caracteres.
 */
export class MinLength {
  /** Función que recibe el control a validar*/
  static minLengthPassword(control: AbstractControl) {
    /** constante que captura el valor del control al cual se le aplicará la validación*/
    const min = control.value;
    if (min.length < 8) {
      return { minlengthPassword: true };
    } else {
      return null;
    }
  }
}
